import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPin7 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M12 2c7 0 8 5.5 8 8 0 6.4-5.333 10.5-8 12-2.667-1.5-8-5.6-8-12 0-2.5 1-8 8-8m0 10q3 0 3-3t-3-3-3 3 3 3'
      clipRule='evenodd'
    />
    <path
      fill='#fff'
      d='m12 22-.245.436a.5.5 0 0 0 .49 0zm8.5-12c0-1.3-.257-3.412-1.459-5.215C17.817 2.95 15.655 1.5 12 1.5v1c3.345 0 5.183 1.301 6.209 2.84C19.257 6.912 19.5 8.8 19.5 10zm-8.255 12.436c1.372-.772 3.425-2.208 5.14-4.28C19.103 16.081 20.5 13.348 20.5 10h-1c0 3.053-1.27 5.569-2.885 7.519-1.618 1.953-3.565 3.317-4.86 4.045zM3.5 10c0 3.348 1.397 6.081 3.115 8.156 1.715 2.072 3.768 3.508 5.14 4.28l.49-.872c-1.295-.728-3.242-2.092-4.86-4.045C5.77 15.569 4.5 13.053 4.5 10zM12 1.5c-3.655 0-5.817 1.449-7.041 3.285C3.757 6.588 3.5 8.7 3.5 10h1c0-1.2.243-3.088 1.291-4.66C6.817 3.802 8.655 2.5 12 2.5zM14.5 9c0 .923-.23 1.523-.604 1.896-.373.374-.973.604-1.896.604v1c1.077 0 1.977-.27 2.604-.896.626-.627.896-1.527.896-2.604zM12 6.5c.923 0 1.523.23 1.896.604.374.373.604.973.604 1.896h1c0-1.077-.27-1.977-.896-2.604C13.977 5.77 13.077 5.5 12 5.5zM9.5 9c0-.923.23-1.523.604-1.896.373-.374.973-.604 1.896-.604v-1c-1.077 0-1.977.27-2.604.896C8.77 7.023 8.5 7.923 8.5 9zm2.5 2.5c-.923 0-1.523-.23-1.896-.604C9.73 10.523 9.5 9.923 9.5 9h-1c0 1.077.27 1.977.896 2.604.627.626 1.527.896 2.604.896z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPin7)
export default ForwardRef
